module.exports = "/images/shield-checkmark-gold.svg?ecd157d79bb49fc9fa397e3d7c746484";